<template>
  <a-upload name="file"
            list-type="picture-card"
            :show-upload-list="false"
            :action="uploadUrl"
            :data="params"
            :before-upload="beforeUpload"
            @change="handleChange">
    <img v-if="imageUrl"
         :src="imageUrl"
         alt="avatar"
         class="imgUrl" />
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        上传图片
      </div>
    </div>
  </a-upload>
</template>

<script>
import env from '../../../../env/index'

function getImgShow(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export default {
  name: 'Uploads',
  data() {
    return {
      loading: false,
      imageUrl: '',
      params: {}, // 上传需要的参数
      uploadUrl: '',
    }
  },
  created() {
    this.uploadUrl = `${env.BFS_USER_WEB_SERVER}/bfs_oss/upload`
  },
  methods: {
    handleChange(info) {
      const { status } = info.file
      // status: uploading done error removed
      if (status === 'uploading') {
        this.loading = true
        return
      }
      if (status === 'done') {
        // Get this url from response in real world.
        getImgShow(info.file.originFileObj, (imageUrl) => {
          this.imageUrl = imageUrl
          this.loading = false
        })

        this.$emit('uplosdImg', info.file.response)
      } else {
        this.$message.error('上传失败')
        this.loading = false
      }
    },
    beforeUpload(file) {
      const type = file.name.split('.')[1]
      this.params = { fileExtension: type, scene: btoa('image') }
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('格式错误,请重新上传!')
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('请上传不超过5M的图片!')
      }
      return isJpgOrPng && isLt5M
    },
  },
}
</script>

<style lang="less" scoped>
.imgUrl {
  width: 100% !important;
  height: 102px !important;
}
</style>>
